(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ak-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ak-countdown')) {
    customElements.define(
      'ak-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: this.dataset.tz || 'Europe/Stockholm',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23',
          }).formatToParts(new Date());
          const get = (type) => Number(parts.find((p) => p.type === type).value);
          let left = 86400 - (get('hour') * 3600 + get('minute') * 60 + get('second'));
          if (left <= 0) left = 86400;
          const pad = (n) => String(n).padStart(2, '0');
          const h = Math.floor(left / 3600);
          const m = Math.floor((left % 3600) / 60);
          const s = left % 60;
          this.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ak-product-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ak-carousel')) {
    customElements.define(
      'ak-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');

          if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
          if (this.next) this.next.addEventListener('click', () => this.step(1));

          this.onScroll = () => this.update();
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          // Bij het wisselen van vensterbreedte verandert het aantal dia's per
          // beeld, dus ook of er nog iets te schuiven valt.
          if ('ResizeObserver' in window) {
            this.observer = new ResizeObserver(() => this.update());
            this.observer.observe(this.track);
          }

          this.update();
        }

        disconnectedCallback() {
          if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
          if (this.observer) this.observer.disconnect();
        }

        step(direction) {
          const slide = this.track.querySelector('.ak-pgal__slide');
          let amount = this.track.clientWidth;
          if (slide) {
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            amount = slide.getBoundingClientRect().width + gap;
          }
          this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          // Past alles in beeld? Dan zijn de pijlen alleen maar ruis.
          this.classList.toggle('ak-pgal__carousel--static', max <= 2);
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
